import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { SelectControl } from '../../ui-kit/Select/SelectControl.js';
import { validatorObj } from './getObjectValidator.js';
import { getValidation } from './getValidation.js';
export const ACQUIRING_TYPES = [
    {
        text: 'Торговый эквайринг',
        key: 'trade',
    },
    {
        text: 'СБП-эквайринг',
        key: 'sbp',
    },
    {
        text: 'Интернет-эквайринг',
        key: 'internet',
    },
    {
        text: 'Все виды эквайринга',
        key: 'all',
    },
];
export const AcquiringField = JSX(({ field, input }) => (_jsx(SelectControl, { label: "\u0412\u0438\u0434 \u044D\u043A\u0432\u0430\u0439\u0440\u0438\u043D\u0433\u0430", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u044D\u043A\u0432\u0430\u0439\u0440\u0438\u043D\u0433", options: ACQUIRING_TYPES, ...getValidation(field('acquiringType'), validatorObj.acquiringType, input?.required) })));
export const isAcquiringTrade = (key = '') => Boolean(key === 'trade' || key === 'all');
//# sourceMappingURL=AcquiringField.js.map